import { useParams } from 'react-router-dom';
import { useGetAsset } from 'features/assetControl/hooks/useGetAsset';
import { getAssetLabel } from 'utils/formatters';

export function AssetBreadcrumb() {
  const { unitExternalIdentifier = '' } = useParams();
  const { asset } = useGetAsset(unitExternalIdentifier);

  return asset ? getAssetLabel(asset) : unitExternalIdentifier;
}
